export default class MapPopupController {
    /** @ngInject */
    constructor(marker, centerCoordinates, updateMarker, isEditing, DialogService, EventEmitter) {
        this.marker = marker;
        this.isEditing = isEditing;
        this.updateMarker = updateMarker;
        this.centerCoordinates = centerCoordinates;
        this.DialogService = DialogService;
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.currentMarker = null;
    }

    cancel() {
        this.DialogService.cancel();
    }

    remove() {
        this.currentMarker = null;
        this.marker = this.currentMarker;

        this.done();
    }

    update({ marker }) {
        this.currentMarker = marker;
    }

    done() {
        this.updateMarker(this.currentMarker);
        this.cancel();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-location/map-popup/map-popup.controller.js